<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";

export default {
  name: "DynamicAppDateElement",
  extends: BrandedTextElement,
  mixins: [UserProfilePageElementMixin, DateElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "DynamicAppDateElement",
    displayIcon: "document",
    elementGroup: "currentUser",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const date = this.valueFromContext;
      if (!date && (this.editMode || this.isPreviewMode)) {
        const field = this.elementContext?.field;
        return field ? camelToTitleCase(field) : this.$options.elementPanelSettings.displayName;
      }
      return this.formattedDate(date);
    },
  },
};
</script>
